import { render, staticRenderFns } from "./space-audit.vue?vue&type=template&id=1462b71d&scoped=true"
import script from "./space-audit.vue?vue&type=script&lang=js"
export * from "./space-audit.vue?vue&type=script&lang=js"
import style0 from "./space-audit.vue?vue&type=style&index=0&id=1462b71d&prod&scoped=true&lang=css"
import style1 from "./space-audit.vue?vue&type=style&index=1&id=1462b71d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1462b71d",
  null
  
)

export default component.exports